module.exports = __webpack_public_path__ + "img/field.ac670689.webp";